module.exports = __webpack_public_path__ + "img/PL08467.b2f97b4d.png";